import React from 'react';
import './AssetsGallery.css';

function AssetsGallery() {
  const galleryItems = [
    { id: 1, image: 'gallery-1.jpg', title: 'Universidad tecnológica en Berlín, Alemania.', caption: 'Dos edificios de 7 mil y 11 mil metros cuadrados, ambos arrendados a dos universidades tecnológicas en Berlín.' },
    { id: 2, image: 'gallery-2.jpg', title: 'Promoción Residencial en Mallorca, España.', caption: 'Promoción residencial de 18 viviendas, 47 plazas de Parking y 18 trasteros ubicada en la isla de Mallorca.' },
    { id: 3, image: 'gallery-3.jpg', title: 'Edificio de oficinas en Charleroi, Bélgica.', caption: 'Edificio de oficinas de 4.150 metros cuadrados ubicado en Charleroi, Bélgica. Coinversión con el Fondo Benou.' },
    { id: 4, image: 'gallery-4.jpg', title: 'Edificio de oficinas en Berlín, Alemania.', caption: 'Edificio de oficinas de 6.400 metros cuadrados ubicado en Berlín, Alemania.' },
    { id: 5, image: 'gallery-5.jpg', title: 'Complejo Comercial en Miami, Florida.', caption: 'Complejo comercial de 32 locales ubicado en Miami, Florida.' },
    { id: 6, image: 'gallery-6.jpg', title: 'Edificio Residencial en Menorca, España.', caption: 'Edificio residencial con 6 viviendas y un local comercial ubicado en la isla de Menorca.' },
    { id: 7, image: 'gallery-7.jpg', title: 'Edificio Residencial en Gamla Stan, Suecia.', caption: 'Edificio residencial de lujo con 9 viviendas y un local ubicado en Gamla Stan, Suecia.' },
    { id: 8, image: 'gallery-8.jpg', title: 'Promoción Turística en Mallorca, España.', caption: 'Promoción turística de 52 apartamentos vacacionales ubicados en la isla de Mallorca. Proyecto participado.' },
    { id: 9, image: 'gallery-9.jpg', title: 'Hotel en Hamelín, Alemania.', caption: 'Hotel de 4 estrellas con 98 habitaciones, spa y gimnasio, ubicado en Hamelín, Alemania. Actualmente está gestionado por una empresa del grupo alemán.' },
    { id: 10, image: 'gallery-10.jpg', title: 'Vivienda en Palma de Mallorca, España.', caption: 'Vivienda reformada de 80m2 y con dos habitaciones en el centro neurálgico de Palma de Mallorca. Actualmente arrendado.' },
    { id: 11, image: 'gallery-11.jpg', title: 'Terreno en Mahón, Menorca.', caption: 'Terreno rural con proyecto para la realización de una vivienda unifamiliar en la zona.' }
  ];

  return (
    <section className="assets-gallery-section">
      <div className="container">
        <p className="assets-intro-text">
          En Tabia Group nos enorgullece desempeñar un papel clave como motor económico de las empresas que conforman nuestro portafolio. Nuestro enfoque se centra en identificar, invertir y potenciar el valor de proyectos excepcionales.
        </p>
        <div className="gallery-grid">
          {galleryItems.map((item) => (
            <div key={item.id} className="gallery-item">
              <div className="gallery-image-wrapper">
                <img src={`${process.env.PUBLIC_URL}/${item.image}`} alt={item.title} />
              </div>
              <h4 className="gallery-title">{item.title}</h4>
              <p className="gallery-caption">{item.caption}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AssetsGallery;
